import React from 'react';
import BaseTemplate from './base.js';
import {ImageElement,RatingElement,ContentElement,Bubble} from './elements.js';
import Details from './details.js';
import * as u from '../utils.js'

/*---------------------------------------------*/

const MOBILE_STYLE = {
	container: {
		paddingTop: 32,
		paddingBottom: 32,
		paddingLeft: 24,
		paddingRight: 24
	},
	bubbleInner: {
		paddingTop: 20,
		paddingBottom: 16,
		paddingLeft: 16,
		paddingRight: 16
	},
	content: {
		lineHeight: 1.5
	}
}

const BREAKPOINTS_STYLES = {
	400: {
		container: {
			paddingTop: 32,
			paddingBottom: 32,
			paddingLeft: 24,
			paddingRight: 24
		},
		bubbleInner: {
			paddingTop: 20,
			paddingBottom: 20,
			paddingLeft: 16,
			paddingRight: 16
		},
		content: {
			lineHeight: 1.5
		}
	},
	720: {
		container: {
			paddingTop: 32,
			paddingBottom: 32,
			paddingLeft: 40,
			paddingRight: 40
		},
		bubbleInner: {
			paddingTop: 20,
			paddingBottom: 20,
			paddingLeft: 24,
			paddingRight: 24
		},
		content: {
			lineHeight: 1.5
		}
	},
	960: {
		container: {
			paddingTop: 32,
			paddingBottom: 32,
			paddingLeft: 48,
			paddingRight: 48
		},
		bubbleInner: {
			paddingTop: 20,
			paddingBottom: 20,
			paddingLeft: 32,
			paddingRight: 32
		},
		content: {
			lineHeight: 1.75
		}
	},
	Infinity: {
		container: {
			paddingTop: 32,
			paddingBottom: 32,
			paddingLeft: 56,
			paddingRight: 56
		},
		bubbleInner: {
			paddingTop: 20,
			paddingBottom: 20,
			paddingLeft: 40,
			paddingRight: 40
		},
		content: {
			lineHeight: 1.75
		}
	}
}

/*---------------------------------------------*/

export default class SimpleBubbleTemplate extends BaseTemplate {
	getComposition() {
		let textPosition = this.context.get('template.textposition');
		let composition = (textPosition === 'top') ? ['content','details'] : ['details','content'];

		let ratingEnabled = this.context.get('fields.rating.enabled');
		if (ratingEnabled && this.props.data.rating) {
			let ratingPosition = this.context.get('template.ratingposition2');
			ratingPosition = {
				'top': {
					'above': 0,
					'below': 1
				},
				'bottom': {
					'above': 1,
					'below': 2
				}
			}[textPosition][ratingPosition];
			
			composition.splice(ratingPosition,0,"rating");
		}

		return composition.join('-');
	}

	render() {
		let data = this.props.data;
		
		let textPosition = this.context.get('template.textposition');
		
		const SIZES_PRESETS = {xs:40, s:64, m:96, l:120, xl:160};
		let imageBorderWidth = this.context.get('style.image.border.width',0);
		let imageSize = this.context.get('style.image.size',64,56);
		imageSize = imageSize in SIZES_PRESETS ? SIZES_PRESETS[imageSize] : 1*imageSize;

		let imageEnabled = this.context.get('fields.image.enabled',true);
		let imageMargin = 1*imageEnabled && 1*this.context.get('fields.image.margin',16);
		let alignment = this.context.get('template.simple.alignment','left');
		let responsiveStyle = this.context.isMobile() ? MOBILE_STYLE : u.getBreakpointStyle(BREAKPOINTS_STYLES,this.props.width);

		let aligns = {
			top: {},
			size: {
				bubble: 1
			},
			sizeBottom: {}
		}

		if (textPosition === 'bottom') {
			aligns.top.bubble = 1;
		} else {
		}

		let D = (alignment === 'left') ?
			{
				marginLeft: 'marginLeft',
				marginRight: 'marginRight',
				paddingLeft: 'paddingLeft',
				paddingRight: 'paddingRight'
			} :
			{
				marginLeft: 'marginRight',
				marginRight: 'marginLeft',
				paddingLeft: 'paddingRight',
				paddingRight: 'paddingLeft'
			};

		let pointer = {
			size: 1*this.context.get('template.bubble.pointerSize',16),
			direction: null,
			offset: null
		}

		let styles =  {
			container: {
				...this.props.baseStyle,
				...responsiveStyle.container,
				textAlign: alignment,
				// transition: 'padding .1s',
				width: '100%'
			},
			rating: {
				fontSize: 1*this.context.get('ratingFontSize',16)
			},
			content: {
				...responsiveStyle.content
			},
			image: {
				display: 'inline-block',
				gridRow: 1,
				fontSize: 0, // reduced extra space
				marginTop: 4
			},
			detailsBlock: {
				display: 'inline-grid',
				gridTemplateColumns: `auto ${imageMargin}px auto`,
				alignItems: 'start'
			},
			details: {
				display: 'inline-block',
				gridColumn: 2
			},
			bubble: {
			},
			bubbleInner: {
				...responsiveStyle.bubbleInner,
				transition: 'padding .1s'
			}
		}

		if (this.context.get('style.lineHeight')) {
			styles.content.lineHeight = this.context.get('style.lineHeight');
		}
		
		if (this.props.content) {
			return (
				<div className="testimonial" style={styles.container} align-group={this.props.alignGroup} ref={this.container}>
					{this.props.content}
				</div>
			)
		}

		let alignProps = {};
		if (this.props.alignGroup) {
			Object.keys(aligns.top).forEach(key => {
				if (aligns.top[key]) {
					alignProps[key] = alignProps[key] || {};
					alignProps[key][['details','detailsBlock'].includes(key) ? 'align-top' : 'alignTop'] = this.props.alignGroup+aligns.top[key];
				}
			})

			Object.keys(aligns.size).forEach(key => {
				if (aligns.size[key]) {
					alignProps[key] = alignProps[key] || {};
					alignProps[key][['details','detailsBlock'].includes(key) ? 'align-group' : 'alignGroup'] = this.props.alignGroup+aligns.size[key];
				}
			})

			Object.keys(aligns.sizeBottom).forEach(key => {
				if (aligns.sizeBottom[key]) {
					alignProps[key] = alignProps[key] || {};
					alignProps[key][['details','detailsBlock'].includes(key) ? 'align-size-bottom' : 'alignSizeBottom'] = this.props.alignGroup+aligns.sizeBottom[key];
				}
			})
		}

		let composition = this.getComposition();
		let components = {
			content: <ContentElement {...alignProps.content} text={data.text} baseStyle={styles.content} key="content" />,
			rating: <RatingElement {...alignProps.rating} rating={data.rating} baseStyle={styles.rating} key="rating" />,
			details: <div {...alignProps.details} key="details"><Details data={data} alignment={alignment} /></div>
		}

		let composition_list = composition.split('-')
		switch (composition) {
			case 'details-content': 
				composition_list = ['details',['content']];
				pointer.direction = 'top';
				
				styles.bubble.marginTop = 21;
				break;

			case 'content-details': 
				composition_list = [['content'],'details'];
				pointer.direction = 'bottom';
				
				styles.bubble.marginBottom = 24 - styles.image.marginTop;
				break;

			case 'rating-details-content': 
				composition_list = ['details',['content']];
				pointer.direction = 'top';
				
				styles.bubble.marginTop = 21;
				styles.rating.marginBottom = 4;
				
				components.details = (
					<div>
						{components.rating}
						{components.details}
					</div>
				)
				break;

			case 'details-rating-content':
				composition_list = ['details',['rating','content']];
				pointer.direction = 'top';
				
				styles.bubble.marginTop = 21;
				styles.rating.marginBottom = 5;
				break;

			case 'details-content-rating': 
				composition_list = ['details',['content','rating']];
				pointer.direction = 'top';
				
				styles.bubble.marginTop = 21;
				styles.content.marginBottom = 7;
				break;

			case 'rating-content-details':
				composition_list = [['rating','content'],'details'];
				pointer.direction = 'bottom';
				
				styles.bubble.marginBottom = 24 - styles.image.marginTop;
				styles.rating.marginBottom = 5;
				break;
				
			case 'content-rating-details':
				composition_list = [['content','rating'],'details'];
				pointer.direction = 'bottom';
				
				styles.bubble.marginBottom = 24 - styles.image.marginTop;
				styles.content.marginBottom = 7;
				break;

			case 'content-details-rating':
				composition_list = [['content'],'details'];
				pointer.direction = 'bottom';
				
				styles.bubble.marginBottom = 21;
				styles.rating.marginTop = 1;

				components.details = (
					<div>
						{components.details}
						{components.rating}
					</div>
				)
				break;

			default:
				console.error("Invalid composition value",composition);
				break;
		}

		pointer.offset = ((alignment) => {
			if (alignment === 'center') 
				return '50%';
			
			var offset = imageSize/2 + imageBorderWidth;
			if (!this.context.isMobile())
				offset += styles.bubbleInner[D.paddingLeft];

			offset += 'px';
			if (alignment === 'right')
				offset = `calc(100% - ${offset})`;
			
			return offset;

		})(alignment);

		
		if (imageEnabled) {
			if (!this.context.isMobile())
				styles.image[D.marginLeft] = styles.bubbleInner[D.paddingLeft];

		} else {
			styles.details[D.marginLeft] = styles.bubbleInner[D.paddingLeft];
		}


		if (alignment === 'right') {
			styles.detailsBlock.textAlign = 'right';
			styles.detailsBlock.justifyContent = 'end';
			styles.details.gridColumn = 1;
			styles.image.gridColumn = 3;

		} else {
			styles.detailsBlock.textAlign = imageEnabled ? 'left' : '';
			styles.detailsBlock.justifyContent = 'start';
			styles.details.gridColumn = 3;
			styles.image.gridColumn = 1;
		}

		if (this.props.part === 'thumbnail') {
			styles.thumbnail = {
				margin: '0 12px',
				overflow: 'hidden',
				transition: `max-width .25s`,
				maxWidth: imageSize + imageBorderWidth*2
			}

			if (this.props.selected) {
				styles.thumbnail.maxWidth = this.detailsRef && this.detailsRef.current && this.detailsRef.current.offsetWidth;
				if (!styles.thumbnail.maxWidth)
					setTimeout(() => this.forceUpdate());
			}
		}

		components.details = (
			<div style={styles.detailsBlock} key="details">
				<div style={styles.details}>{components.details}</div>
				<ImageElement image={data.author_image} size={imageSize} baseStyle={styles.image} />
			</div>
		)

		if (this.props.part === 'thumbnail') {
			components.details = (
				<div style={styles.thumbnail}>
					{components.details}
				</div>
			)
		}

		let partialDisplay = true;
		switch (this.props.part) {
			case 'top':
				if (textPosition !== 'top')
					return null;
					
				composition_list = composition_list.slice(0,1);
				break;
			
			case 'bottom':
				if (textPosition !== 'bottom')
					return null;

				composition_list = composition_list.slice(1,2);
				break;
			
			case 'thumbnail':
				composition_list = ['details'];
				break;
			
			default:
				partialDisplay = false;
				break;
		}
		
		var content = composition_list.map((type) => {
			if (typeof type === 'string')
				return components[type];
			
			let props = {
				// alignGroup: this.props.alignGroup ? (this.props.alignGroup-1) : 0,
				direction: pointer.direction,
				pointerSize: pointer.size,
				pointerOffset: pointer.offset,
				baseStyle: styles.bubble,
				baseInnerStyle: styles.bubbleInner
			}

			if (this.props.thumbnailOffset)
				props.pointerOffset = this.props.thumbnailOffset;

			return (
				<Bubble {...props} {...alignProps.bubble} key="bubble">
					{type.map((type) => components[type])}
				</Bubble>
			)
		});

		if (partialDisplay)
			return content;

		let hasContainer = this.context.get('template.container',true);
		if (!hasContainer) {
			styles.container.paddingTop = 0;
			styles.container.paddingBottom = 0;
			styles.container.paddingLeft = 0;
			styles.container.paddingRight = 0;
		}
		
		return (
			<div className="testimonial" style={styles.container} align-group={this.props.alignGroup} ref={this.container}>
				{content}
			</div>
		)
	}
}

/*---------------------------------------------*/
